export const hotspotPages = [
    { key: 'home', title: '首页', route: '/' },
    { key: 'products', title: '产品', route: '/products' },
    { key: 'solutions', title: '解决方案', route: '/solutions' },
    { key: 'contact', title: '联系我们', route: '/contact' },
    { key: 'smart-hotel', title: '智慧酒店', route: '/solutions/smartHotel' },
]

export function findPage(key) {
    return hotspotPages.find((item) => item.key === key)
}

export function productDetailPath(product) {
    const id = Number(product?.id)
    const name = String(product?.name || 'product').trim() || 'product'
    return `/product/detail/${name}/${id}`
}

export function productHotspotPage(product) {
    const name = String(product?.name || '').trim() || `产品 ${product.id}`
    return {
        key: `product-${product.id}`,
        title: name,
        route: productDetailPath(product),
    }
}

export function isProductDetailRoute(path) {
    return /^\/product\/detail\/[^/]+\/\d+$/.test(path || '')
}
